import React, { useEffect } from 'react';

export const PreventBackButton = () => {
  useEffect(() => {
    // Push the current URL into the history to disable back button
    window.history.pushState(null, "", window.location.href);

    function preventBackButtonHandler() {
      window.history.pushState(null, "", window.location.href);
    }

    // Prevent navigating back by pushing the state again on popstate event
    window.addEventListener("popstate", preventBackButtonHandler);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", preventBackButtonHandler);
    };
  }, []);

  return (
    <></>
  );
};
